module.exports = __webpack_public_path__ + "img/Efectivo.ad870da9.png";